import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from 'src/app/shared/pipes/translate.pipe';
import { FilterService } from 'src/app/shared/services/filter.service';
import { GlobalService } from 'src/app/shared/services/global.service';
import { TimelineService } from 'src/app/timeline/timeline.service';

@Component({
    selector: 'app-add-task',
    templateUrl: './add-task.component.html',
    styleUrls: ['./add-task.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AddTaskComponent implements OnInit {

	@Input() task: any;
	@Input() phase: any;
	@Input() project: any;
	@Input() infoProjectPhases: any;
	@Input() module: any;
	@Input() position: number;
	@Output() closeView = new EventEmitter<any>();
	@Output() notify = new EventEmitter<any>();

	loading: boolean = false;
	formData: any = {
		'id': undefined,
		'task_name': '',
		'project_has_phase_id': '',
		'predecessor_id': -1,
		'task_start_at_id': 2,
		'task_unit_id': '',
		'duration': '',
		'task_duration_type_id': 2,
		'break': 0,
		'break_task_duration_type_id': 1,
		'work_days': 6,
		'break_episode': null,
		'post_color': '#edc1fd',
		'position': null,
		'task_countrys': [],
		'date_task': ''
	}
	predecessors: any[] = [];
	weeks: boolean = false;
	disablePre: boolean = false;
	disabledDate: boolean = false;
	durationWeek: number = 0;
	showError: boolean = false;
	predecessorsFilter: any[] = [];

	ValidateWeek(){
		this.weeks = false;
		this.disablePre = false;
		if(this.formData.task_unit_id == 2){
			this.formData.task_duration_type_id = 2;
			if (!this.task) this.formData.duration = '';
			this.weeks = true;
		}
		else if (this.formData.task_unit_id == 3) {
			this.formData.task_duration_type_id = 1;
			this.formData.predecessor_id = -1;
			this.formData.duration = 1;
			this.weeks = true;
			this.disablePre = true;
		}
		else this.weeks = false
	}

	submitForm() {
		this.loading = true;
		this.formData.predecessor_id = this.formData.predecessor_id != -1 ? this.formData.predecessor_id : null;
		this.formData.task_start_at_id = this.formData.predecessor_id ? this.formData.task_start_at_id : null;
		// work days visible only when task unit is chapters
		this.formData.work_days = this.formData.task_duration_type_id == 1 ? this.formData.work_days : null;
		// color saved only when in post production
		this.formData.post_color = this.module.name == 'post' ? this.formData.post_color : null;
		// send position
		this.formData.position = this.task ? this.formData.position : null;
		// Error
		if (this.task && this.formData.task_unit_id == 2 && this.formData.duration < this.durationWeek) {
			this.loading = false;
			if (!this.task.predecessor_id) this.formData.predecessor_id = -1;
			this.showError = true;
			return;
		}
		this._tS.createPhaseTask(this.formData).subscribe(
			data => {
				this.loading = false;
				this.notify.emit();
			}
		)
	}

	close() {
		this.closeView.emit()
	}

	fillForm() {
		this.formData = {
			'id': this.task.id,
			'task_name': this.task.task_name,
			'project_has_phase_id': this.task.project_has_phase_id,
			'predecessor_id': this.task.predecessor_id ? this.task.predecessor_id : -1,
			'task_start_at_id': this.task.task_start_at_id ? this.task.task_start_at_id : 2,
			'task_unit_id': this.task.task_unit_id,
			'duration': this.task.duration,
			'task_duration_type_id': this.task.task_duration_type_id,
			'break': this.task.break,
			'break_task_duration_type_id': this.task.break_task_duration_type_id,
			'work_days': this.task.work_days ? this.task.work_days : 6,
			'break_episode': this.task.break_episode ? this.task.break_episode : null,
			'post_color': this.task.post_color ? this.task.post_color : '#edc1fd',
			'position': this.task.position,
			'task_countrys': [],
			'date_task': this.task.defined_date
		}
		if (this.task.task_country.length) {
			this.formData.task_countrys = this.infoProjectPhases.countries.filter(c => this.task.task_country.find(tc => tc.id == c.id))
		}
	}

	formIsValid() {
		return this.formData.project_has_phase_id &&
			this.formData.task_unit_id &&
			this.formData.task_duration_type_id;
	}

	onChangePhase() {
		this.loading = true;
		this._tS.listPredecessor(this.formData.project_has_phase_id).subscribe(
			(data: any) => {
				this.predecessors = data.predecessor;
				if(this.task?.id){
				this.predecessors = this.predecessors.filter(p => p.id != this.task.id)}
				let noPredecessor = {
					'id': -1,
					'task_name': this._trS.transform('No predecessor'),
				}
				this.predecessors.unshift(noPredecessor);
				this.predecessorsFilter = this.predecessors;
				this.loading = false;
			}
		)
	}

	filterPredecessor() {
		this.predecessorsFilter = this.predecessors;
		this.predecessorsFilter = this.predecessorsFilter.filter((item: any) => item.task_unit_id == this.formData.task_unit_id);
		let noPredecessor = {
			'id': -1,
			'task_name': this._trS.transform('No predecessor'),
		}
		this.predecessorsFilter.unshift(noPredecessor);
	}

	constructor(public _gS: GlobalService, private _tS: TimelineService, private _trS: TranslatePipe, private _fS: FilterService) { }

	ngOnInit() {
		if (this.task) {
			this.fillForm();
			if (this.task?.received && this.task?.task_unit_id == 3) this.disabledDate = true;
			if (this.task?.received && this.task?.task_unit_id == 2) this.durationWeek = this.task.duration;
		}
		if (this.phase) {
			this.formData.project_has_phase_id = this.phase.id;
			this.onChangePhase();
		}
	}

}
